import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { putRequest } from '../../../../requestUtils';
import './InterviewMeetingDetails.scss';
var InterviewMeetingDetails = /*#__PURE__*/function (_React$Component) {
  function InterviewMeetingDetails(props) {
    var _this;
    _classCallCheck(this, InterviewMeetingDetails);
    _this = _callSuper(this, InterviewMeetingDetails, [props]);
    var defaultMeetingDetails = _this.props.meetingDetails || '';
    _this.state = {
      meetingDetails: defaultMeetingDetails,
      displayedMeetingDetails: defaultMeetingDetails,
      isEditing: false
    };
    _this.handleEditMeetingLink = _this.handleEditMeetingLink.bind(_this);
    _this.handleSubmitMeeting = _this.handleSubmitMeeting.bind(_this);
    return _this;
  }
  _inherits(InterviewMeetingDetails, _React$Component);
  return _createClass(InterviewMeetingDetails, [{
    key: "handleEditMeetingLink",
    value: function handleEditMeetingLink() {
      this.setState({
        isEditing: true
      });
    }
  }, {
    key: "handleSubmitMeeting",
    value: function handleSubmitMeeting() {
      var _this2 = this;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        editInterviewPath = _this$props.editInterviewPath,
        onSubmit = _this$props.onSubmit;
      var _this$state = this.state,
        meetingDetails = _this$state.meetingDetails,
        displayedMeetingDetails = _this$state.displayedMeetingDetails;
      if (meetingDetails === displayedMeetingDetails) {
        this.setState({
          isEditing: false
        });
        return;
      }
      var params = {
        interview: {
          meeting_details: meetingDetails
        },
        project_permissions: {}
      };
      putRequest(editInterviewPath, params, csrfToken).then(function (response) {
        onSubmit(response);
        _this2.setState({
          isEditing: false,
          displayedMeetingDetails: meetingDetails
        });
      });
    }
  }, {
    key: "renderMeetingLink",
    value: function renderMeetingLink() {
      var displayedMeetingDetails = this.state.displayedMeetingDetails;
      if (displayedMeetingDetails) {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 medium-weight"
        }, "Meeting room details:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 normal-weight text-prewrap mt-4"
        }, displayedMeetingDetails));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight"
      }, "Clora will post the details here when the meeting room is set up.");
    }
  }, {
    key: "renderMeetingLinkInput",
    value: function renderMeetingLinkInput() {
      var _this3 = this;
      var _this$state2 = this.state,
        isEditing = _this$state2.isEditing,
        meetingDetails = _this$state2.meetingDetails;
      var ctaCopy = meetingDetails ? 'Edit meeting details' : '+ Add meeting details';
      if (!isEditing) {
        return /*#__PURE__*/React.createElement("a", {
          className: "edit-meeting-link-cta medium-weight body-text-2",
          role: "button",
          tabIndex: "0",
          onClick: this.handleEditMeetingLink
        }, ctaCopy);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting-link-input"
      }, /*#__PURE__*/React.createElement("textarea", {
        value: meetingDetails,
        rows: "4",
        onChange: function onChange(e) {
          return _this3.setState({
            meetingDetails: e.target.value
          });
        },
        id: "meeting-link",
        name: "meeting-link"
      }), /*#__PURE__*/React.createElement("a", {
        onClick: this.handleSubmitMeeting,
        role: "button",
        tabIndex: "0",
        className: "btn btn-primary small submit-meeting-link mt-3"
      }, "Submit"));
    }
  }, {
    key: "render",
    value: function render() {
      var isRep = this.props.isRep;
      var isEditing = this.state.isEditing;
      return /*#__PURE__*/React.createElement("div", {
        className: "interview-meeting-details style-guide"
      }, isRep && /*#__PURE__*/React.createElement("div", {
        className: "meeting-link-input-container mb-8"
      }, this.renderMeetingLinkInput()), !isEditing && this.renderMeetingLink());
    }
  }]);
}(React.Component);
InterviewMeetingDetails.propTypes = {
  meetingDetails: PropTypes.string,
  editInterviewPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  onSubmit: PropTypes.func
};
InterviewMeetingDetails.defaultProps = {
  meetingDetails: null,
  isRep: false,
  onSubmit: function onSubmit() {
    return null;
  }
};
export default InterviewMeetingDetails;